import { useEffect, useState } from 'react';
import { mediaApi } from '@formosa/shared/api/im';
import { useTravelText } from '../../../app/TravelLocaleContext';
import SafeImage from '../../../components/SafeImage';
import { resolveChatImageSrc } from '../travelChatImageModel';
export default function ChatMediaMessage({ message }) {
  const { t } = useTravelText();
  const [resolved, setResolved] = useState('');
  const [failed, setFailed] = useState(false);
  const src = resolveChatImageSrc({ mediaUrl: resolved || message.mediaUrl || message.sticker?.mediaUrl || message.gif?.mediaUrl, objectKey: message.objectKey || message.sticker?.objectKey || message.gif?.objectKey });
  useEffect(() => {
    let cancelled = false; setResolved(''); setFailed(false);
    if (!src && message.conversationId && message.serverMessageId && mediaApi?.resolveByMessage) {
      mediaApi.resolveByMessage(message.conversationId, message.serverMessageId).then(data => { if (!cancelled) setResolved(data.mediaUrl || ''); }).catch(() => { if (!cancelled) setFailed(true); });
    }
    return () => { cancelled = true; };
    // Only resolve missing media, never retry automatically on error.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message.conversationId, message.serverMessageId, message.objectKey, message.mediaUrl]);
  if (!src || failed) return <p>{t('travel.chat.mediaFailed')}</p>;
  if (message.messageType === 'VIDEO') return <video className="travel-chat-media" src={src} controls preload="metadata" onError={() => setFailed(true)} aria-label={message.fileName || t('travel.chat.video')} />;
  if (message.messageType === 'FILE') return <a className="travel-chat-media-link" href={src} download={message.fileName || undefined} target="_blank" rel="noopener noreferrer">{message.fileName || t('travel.chat.download')}</a>;
  return <SafeImage className="travel-chat-media" src={src} alt={message.emoteCode || t(message.messageType === 'GIF' ? 'travel.chat.gifs' : 'travel.chat.stickers')} fallback={<span>{t('travel.chat.mediaFailed')}</span>} />;
}
